module.exports = __WEBPACK_EXTERNAL_MODULE_29__;


//////////////////
// WEBPACK FOOTER
// external "isogd-gis-rest"
// module id = 29
// module chunks = 0